<template>
  <div>
    <!--    <span @click="val=!val" class="subtitle-2" :style="{'color':val?'green':'red'}">{{$t('rules.'+xtag+'_'+xval)}}</span>
    <v-icon @click="val=!val" :color="val?'success':'error'">{{val?"mdi-check":"mdi-close"}}</v-icon>!-->
    <v-btn small text @click="changeVal" :color="val?'success':'grey'">
      <v-icon :color="val?'success':'grey'">{{val?"mdi-check":"mdi-close"}}</v-icon>
      <span v-if="solo"></span>
      <span v-else-if="label">{{$t(label)}}</span>
      <span v-else>{{$t('rules.'+xtag+'_'+xval)}}</span>
    </v-btn>
  </div>
</template>
<script>
export default {
  name: "check_box_rules",
  props: {
    label: {
      type: String,
      default: null
    },
    xtag: {
      type: String,
      required: true
    },
    xval: {
      type: String,
      required: true
    },
    solo: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      //state: false
    };
  },
  computed: {
    val() {
      if (!this.value) return false;
      return new RegExp(
        "<" + this.xtag + ">\\w*" + this.xval + "\\w*</" + this.xtag + ">",
        "gi"
      ).test(this.value);
    }
  },
  methods: {
    changeVal() {
      let nw = !this.val;
      const ts = "<" + this.xtag + ">";
      const te = "</" + this.xtag + ">";
      let test = new RegExp(ts + "(.*)" + te).exec(this.value);
      let res = "";
      if (test) {
        let new_vals =
          test[1].replace(new RegExp(this.xval, "gi"), "") +
          (nw ? this.xval : "");
        res = test.input.replace(
          new RegExp(test[0], "gi"),
          new_vals ? ts + new_vals + te : ""
        );
      } else {
        if (nw) res = this.value + ts + this.xval + te;
      }
      this.$emit("input", res);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>